import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import LikedVakancies from "../../components/likedvakancies/likedvakancies";
import Workersidebar from "./workersidebar";
import BannersProfile from "../../components/bannersprofile/bannersprofile";
import TopVakancies from "../../topvakancies/topvakancies";
import News from "../../components/news/news";
import bannimage from "../../assets/Mainbanner/main.png"
import { UserContext } from "../../components/usercontext/user_context";
const WorkerProfile = () => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const [cvExists, setCvExists] = useState(false);
  const { user, updateUser } = useContext(UserContext);
  const [cv, setCv] = useState(null); // отдельное состояние для CV

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) return;

    fetch(`/api/get_user.php?id=${userId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          updateUser(data.user);

          // Получаем CV
          fetch(`/api/get_cv.php?user_id=${data.user.id}`)
            .then((res) => res.json())
            .then((cvData) => {
              if (cvData.success && cvData.cv) {
                setCv(cvData.cv); // сохраняем весь объект CV
              } else {
                setCv(null);
              }
            })
            .catch(() => setCv(null));
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const handleUpload = (e) => {
    if (!user) return;
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("photo", file);
    formData.append("id", user.id);

    fetch("/api/upload_photo.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          updateUser({ photo: data.photo }); // обновляем фото в контексте
        } else {
          console.error("Upload failed:", data.message);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  };

  return (
    <section className="w-full  flex-1 flex justify-center bg-transparent items-center flex-col  max-lg:h-auto opacity-0 animate-[showtitle_1s_forwards]">
      <section className="flex  w-full justify-center bg-transparent items-start max-lg:gap-2 max-md:flex-col">
        <section className="w-max bg-transparent max-md:w-full p-5 max-lg:p-2 h-auto max-md:p-0 max-md:pt-1 flex justify-start items-start max-md:flex-col max-md:gap-2 gap-6">
          <aside
            className=" overflow-hidden relative w-[350px]  max-md:w-full h-auto flex justify-center p-6 pt-1 items-start flex-col gap-3 rounded-[30px] max-sm:rounded-none shadow-2xl 
          "
          >
            <div
              className="absolute size-full inset-0  bg-cover bg-left"
              style={{
                backgroundImage: `url(${bannimage})`,
              }}
            ></div>
            {/* Полупрозрачный слой с blur */}
            <div className="absolute inset-0 bg-black/10 backdrop-blur-[40px] z-10"></div>
            <header className=" relative w-full h-auto flex-col max-md:flex-row flex justify-start items-start pt-3 z-10  gap-6">
              <div>
                <div className="w-[150px] h-[150px] relative shadow-2xl rounded-2xl overflow-visible bg-gray-200 flex justify-center items-center">
                  {user && user.photo ? (
                    <img
                      src={`/api/uploads/${user.photo}`}
                      alt="user photo"
                      className="w-full h-full rounded-2xl object-cover"
                    />
                  ) : (
                    <span className="text-3xl">📷</span>
                  )}

                  <label className="absolute -bottom-2 -right-2 w-10 h-10 bg-white rounded-full flex items-center justify-center shadow cursor-pointer">
                    📷
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleUpload}
                    />
                  </label>
                </div>
              </div>
              <div className="flex w-full flex-col gap-6">
                {user && (
                  <div className="flex w-full flex-col gap-1">
                    <h1 className="text-xl max-sm:text-[20px] text-white font-semibold">
                      {user.name}
                    </h1>
                    <h3 className="text-2xl max-sm:text-[20px] text-white font-semibold">
                      {user.lastName}
                    </h3>
                    <h4 className="text-xl text-white">ID: {user.id}</h4>
                  </div>
                )}
              </div>
            </header>
            <Workersidebar />
          </aside>
        </section>
        <section className="flex w-full flex-col gap-6 max-md:gap-3">
          <BannersProfile />
          <section className="max-xl:hidden">
            <LikedVakancies />
          </section>
        </section>
      </section>
      <section className="xl:hidden max-xl:flex">
        <LikedVakancies />
      </section>
      <TopVakancies />
      <News />
    </section>
  );
};

export default WorkerProfile;
